import { useCallback } from 'react';
import { useNotificationCore } from '../../../core/modules/notification';
import { useNavigationCore } from '../../../core/router/navigation';
import {
  Notification,
  NotificationAnnouncement,
  NotificationClass,
  NotificationClassComment,
  NotificationForumComment,
} from '../../../core/interfaces/notification.interface';

// Marca la notificación como leída y lleva a su destino. Compartido por el menú de la
// campana y la página de notificaciones (antes cada uno tenía su copia y la de la página
// navegaba dos veces en los comentarios del foro). Si la clase/curso/tema ya no existe,
// no navega en vez de romper.
const useOpenNotification = (onOpen?: () => void) => {
  const { postReadNotification } = useNotificationCore();
  const { goToMeCourse, goToForum, goToAnnouncement } = useNavigationCore();

  return useCallback(
    (notification: Notification) => {
      onOpen?.();
      postReadNotification(String(notification.id), notification.type);

      if (notification.type === 'notification_announcement') {
        const { announcement } = notification as NotificationAnnouncement;
        if (announcement?.id) {
          goToAnnouncement(announcement.id, { announcement });
        }
      } else if (notification.type === 'forumComment') {
        const notif = notification as NotificationForumComment;
        if (notif.course?.id && notif.forumSubject?.id) {
          goToForum(notif.course.id, notif.forumSubject.id);
        }
      } else {
        const notif = notification as NotificationClass | NotificationClassComment;
        if (notif.course?.id) {
          goToMeCourse(notif.course.id, notif.class?.id);
        }
      }
    },
    [goToAnnouncement, goToForum, goToMeCourse, onOpen, postReadNotification],
  );
};

export default useOpenNotification;
